import { render, staticRenderFns } from "./AboutOnlineEducation.vue?vue&type=template&id=56f3148d"
import script from "./AboutOnlineEducation.vue?vue&type=script&lang=js"
export * from "./AboutOnlineEducation.vue?vue&type=script&lang=js"
import style0 from "./AboutOnlineEducation.vue?vue&type=style&index=0&id=56f3148d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports